import useTranslate from "../../../../app/hooks/useTranslate";
import ContactIcon from "../../../../app/icons/ContactIcon";
import NewsLetterIcon from "../../../../app/icons/NewsLetterIcon";
import PartnersIcon from "../../../../app/icons/PartnersIcon";
import SettingsIcon from "../../../../app/icons/SettingsIcon";
import PlanIcon from "../../../../app/icons/PlanIcon";
import SubscriptionIcon from "../../../../app/icons/SubscriptionIcon";
import VideoIcon from "../../../../app/icons/VideoIcon";
import { AsideMenuItem } from "./AsideMenuItem";
import DashboardIcon from "../../../../app/icons/DashboardIcon";

export function AsideMenuMain() {
  const t = useTranslate()
  return (
    <>
      <AsideMenuItem to="/dashboard" icon={<DashboardIcon />} title={t("DASHBOARD")} />
      <AsideMenuItem to="/users" icon={<PartnersIcon />} title={t("USERS")} />

      <AsideMenuItem to="/videos" icon={<VideoIcon/>} title={t("VIDEOS")} />

      <AsideMenuItem to="/subscriptions" icon={<SubscriptionIcon />} title={t("SUBSCRIPTIONS")} />
      <AsideMenuItem to="/plans" icon={<PlanIcon />} title={t("PLANS")} />
      <AsideMenuItem to="/news-letters" icon={<NewsLetterIcon/>} title={t("NEWSLETTER")} />
      <AsideMenuItem to="/academies-partners" icon={<PartnersIcon/>} title={t("PARTNERS")} />
      
      <AsideMenuItem to="/contacts" icon={<ContactIcon/>} title={t("CONTACTS")} /> 
      <AsideMenuItem to="/settings" icon={<SettingsIcon/>} title={t("SETTINGS")} />

      {window.location.pathname === '/user/change-password' && <AsideMenuItem to="/user" icon={<PartnersIcon />} title={t("CHANGE_PASSWORD")} />}
    </>
  );
}
